import axios from "axios";
import { SERVICE_URL, X_API_KEY } from "consts/env";
import { fallbackURL } from "consts/FallbackURL";
import { emit } from "utils/eventManager";

export default async function axiosPost(
    body,
    credentials = false
) {
    const headers = {
        "Content-Type": "application/json",
    };

    if (credentials) {
        headers["x-hooli-token"] = credentials.hooliToken || credentials.token;
        headers["x-session-id"] = credentials.sessionId;
    }

    headers["x-api-key"] = X_API_KEY;
    headers["x-origin-id"] = "PANELSF";

    try {
        const response = await axios.post(SERVICE_URL, body, { headers });
        const result = response.data;
        if (!result || result === null || result === undefined) {
            return {
                status: {
                    code: 0,
                    errcode: 99999,
                    errmsg: "Error inesperado en request",
                    action: "U",
                    id: null,
                },
                result: [],
            };
        }

        if (result?.status?.code !== 1 && result?.status?.errcode === 10000) {
            sessionStorage.clear();
            return window.location.assign(fallbackURL);
        }

        return result;
    } catch (err) {
        return {
            status: {
                code: 0,
                errcode: err.response ? err.response.status : 0,
                errmsg: err.message,
                action: "U",
                id: null,
            },
            result: [],
        };
    }
}
axios.interceptors.response.use(
    (response) => {
        if (response.data?.status?.code !== 1) {
            switch (response.data?.status?.action) {
                case "X": {
                    if (response.data?.status?.errcode === 10000) {
                        window.sessionStorage.setItem("hooliToken", "");
                        window.sessionStorage.setItem("sessionId", "");
                        emit("sessionExpired", {
                            route: "/login",
                            message: response.data.status.errmsg,
                        });
                        return response; // ← devolver response
                    }
                    emit("serverError", {
                        message: response.data.status.errmsg,
                    });
                    return response; // ← devolver response
                }
                case "W": {
                    if (response.data?.status?.errcode === 10000) {
                        window.sessionStorage.setItem("hooliToken", "");
                        window.sessionStorage.setItem("sessionId", "");
                        emit("sessionExpired", {
                            route: "/login",
                            message: response.data.status.errmsg,
                        });
                        return response;
                    }
                    if (response.data?.status?.errcode === 70101) {
                        emit("serverError", {
                            message: response.data.status.errmsg,
                        });
                        return response;
                    }
                    emit("serverError", {
                        message: response.data.status.errmsg,
                    });
                    return response;
                }
                case "E": {
                    if (response.data?.status?.errcode === 10000) {
                        window.sessionStorage.setItem("hooliToken", "");
                        window.sessionStorage.setItem("sessionId", "");
                        emit("sessionExpired", {
                            route: "/login",
                            message: response.data.status.errmsg,
                        });
                        return response;
                    }
                    emit("serverError", {
                        route: "/login",
                        message: "Error de servidor",
                    });
                    return response;
                }
                default: {
                    emit("serverError", {
                        message: response.data.status.errmsg,
                    });
                    return response;
                }
            }
        }

        return response;
    },
    (error) => { console.error(error); return Promise.reject(error); }
);